import React, { FC } from "react";
import TwitterIcon from "@public/social-icons/twitter.svg";
import LinkedInIcon from "@public/social-icons/linkedin.svg";
import GitHubIcon from "@public/social-icons/github.svg";
import InstagramIcon from "@public/social-icons/instagram.svg";
import YouTubeIcon from "@public/social-icons/youtube.svg";
import { Organisation } from "@prisma/client";
import Image from "next/image";
import Link from "next/link";
import { organisationSizeToLabel } from "@utils/enumToLabel/organisationSizeToLabel";

interface Props {
  organisation?: Organisation;
}

export const OrganisationBlock: FC<Props> = ({ organisation }) => (
  <>
    <Link href={`/company/${organisation?.slug}`}>
      {organisation?.favicon ? (
        <div className="py-2">
          <Image
            className="rounded"
            width={48}
            height={48}
            src={`${process.env.NEXT_PUBLIC_SUPABASE_PROJECT_URL}/storage/v1/object/public/public${organisation?.favicon}`}
            alt={`${organisation?.name || ""} logo`}
          />
        </div>
      ) : (
        <div className="flex justify-center items-center w-12 h-12 rounded bg-gray-100 ">
          {organisation?.name?.[0]}
        </div>
      )}
    </Link>
    <div>
      <Link
        href={`/company/${organisation?.slug}`}
        className="inline text-blue-600 font-bold"
      >
        {organisation?.name}
      </Link>
      {organisation?.size ? (
        <span className="ml-2 px-1 py-1 text-gray-600 bg-gray-100 rounded-sm text-xs font-medium ">
          {organisationSizeToLabel[organisation?.size]}
        </span>
      ) : null}
    </div>
    <div>{organisation?.about}</div>
    {(organisation?.twitterUrl ||
      organisation?.linkedinUrl ||
      organisation?.githubUrl) && (
      <div className="flex flex-row mt-2 space-x-4">
        {organisation?.twitterUrl && (
          <a href={organisation?.twitterUrl} title="Twitter" target="_blank">
            <TwitterIcon className="fill-current hover:text-gray-600 h-5" />
          </a>
        )}
        {organisation?.linkedinUrl && (
          <a href={organisation?.linkedinUrl} title="LinkedIn" target="_blank">
            <LinkedInIcon className="fill-current hover:text-gray-600 h-5" />
          </a>
        )}
        {organisation?.githubUrl && (
          <a href={organisation?.githubUrl} title="GitHub" target="_blank">
            <GitHubIcon className="fill-current hover:text-gray-600 h-5" />
          </a>
        )}
        {organisation?.instagramUrl && (
          <a
            href={organisation?.instagramUrl}
            title="Instagram"
            target="_blank"
          >
            <InstagramIcon className="fill-current hover:text-gray-600 h-5" />
          </a>
        )}
        {organisation?.youtubeUrl && (
          <a href={organisation?.youtubeUrl} title="YouTube" target="_blank">
            <YouTubeIcon className="fill-current hover:text-gray-600 h-5" />
          </a>
        )}
      </div>
    )}
  </>
);
